import React, { Fragment, useState, useEffect } from 'react';

// Components
import DownloadDropdown from './common/DownloadDropdown';

// Components
import DownloadBtn_Win from './common/DownloadBtn_Win';
import DownloadBtn_Apple from './common/DownloadBtn_Apple';

// Imgs
import logo from './common/Logo_Round';
  
const Footer = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Toggle Dropdwon
    const [downloadDropdown, setDownloadDropdown] = useState(false);
            
    useEffect(() => {
            
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
        <Fragment>
            {/* Section 1 - Call to action Header */}
            <div style={{paddingBottom: '6rem', boxSizing: 'border-box', maxWidth: '64rem', marginLeft: 'auto', marginRight: 'auto'}}>
                {/* Header + Banners */}
                <div style={{zIndex: 10, width: '100%', textAlign: 'center', paddingLeft: '1rem', paddingRight: '1rem', marginLeft: 'auto', marginRight: 'auto' }}>
                    {/* Heading + CTA Buttons */}
                    <div style={{marginLeft: 'auto', marginRight: 'auto'}}>
                        {/* Title */}
                        <h3 style={{fontSize: '2.25rem', fontWeight: 'bold', marginBottom: '1.5rem'}}>
                            Take the short way.
                        </h3>
                        {/* Description */}
                        <p style={{fontWeight: 500, fontSize: '16px', paddingLeft: '3rem', paddingRight: '3rem', color: 'rgb(172,172,172)', textAlign: 'center', marginBottom: '3rem'}}>
                            Download and use Interview Cheater today.
                        </p>
                        {/* CTA Buttons */}
                        <div style={{display: 'grid', gridTemplateColumns: `${isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}`, width: '100%', gap: '1rem'}}>
                            {/* Download Buttons */}
                            <DownloadBtn_Apple />
                            <DownloadBtn_Win />
                        </div>
                    </div>
                </div>
            </div>

            <footer style={{borderTop: '1px solid rgb(38,38,38)', padding: '3rem 1rem', width: '100%', maxWidth: '1024px', marginLeft: 'auto', marginRight: 'auto', boxSizing: 'border-box'}}>
                {/* Top footer - spaced horizontally */}
                <div style={{display: 'grid', gridTemplateColumns: `${isMobile ? '1fr' : 'repeat(12,minmax(0,1fr))'}`, gap: '2rem'}}>
                    {/* Section 1 in footer */}
                    <div style={{gridColumn: 'span 4/span 4', display: 'flex', flexDirection: 'column', gap: '1.5rem'}}>
                        {/* 1. Logo Container */}
                        <div style={{gap: '1.5rem', display: 'flex', alignItems: 'center'}}>
                            {/* Img - Logo */}
                            <img alt="Interview Cheater" loading="lazy" width="24" height="24" decoding="async" src={logo} style={{borderRadius: '50%', width: '1.5rem', height: '1.5rem'}} />
                            {/* Text - Logo */}
                            <span style={{color: 'rgb(163,163,163)', fontWeight: 'bold', fontSize: '1.25rem', lineHeight: '1.25rem'}}>
                                Interview Cheater
                            </span>
                        </div>
                        {/* 2. Company description */}
                        <div style={{color: 'rgb(115,115,115)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                            Interview Cheater is a desktop app designed to help job seekers ace technical interviews by providing real-time assistance with coding questions.
                        </div>
                        {/* 3. Active Status */}
                        <div style={{padding: '.5rem 1rem', backgroundColor: 'rgb(23,23,23)', borderColor: 'rgb(38,38,38)', border: '1px solid rgb(38,38,38)', borderRadius: '50px', width: 'fit-content', display: 'flex', alignItems: 'center', gap: '.5rem'}}>
                            <div style={{background: 'rgb(34,197,94)', borderRadius: '50%', width: '.5rem', height: '.5rem'}}></div>
                            <span style={{color: 'rgb(163,163,163)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                                All systems online
                            </span>
                        </div>

                    </div>
                    {/* Section 2 in footer */}
                    <div style={{gridColumn: 'span 4/span 4', display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                        <h3 style={{color: 'rgb(163,163,163)', fontWeight: 'bold', margin: '0'}}>
                            Support
                        </h3>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '.5rem'}}>
                            <a href='/help?section=contact' className='white_hover' style={{color: 'rgb(115, 115, 115)', fontSize: '.875rem', textDecoration: 'none'}}>
                                Contact Us
                            </a>
                            <a href='/policies#refund' className='white_hover' style={{color: 'rgb(115, 115, 115)', fontSize: '.875rem', textDecoration: 'none'}}>
                                Refund Policy
                            </a>
                            <a href='/policies#cancel-policy' className='white_hover' style={{color: 'rgb(115, 115, 115)', fontSize: '.875rem', textDecoration: 'none'}}>
                                Cancellation Policy
                            </a>
                            <a href='/policies#terms' className='white_hover' style={{color: 'rgb(115, 115, 115)', fontSize: '.875rem', textDecoration: 'none'}}>
                                Terms of Service
                            </a>
                        </div>
                    </div>
                    {/* Section 3 in footer */}
                    <div style={{gridColumn: 'span 4/span 4', display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                        <h3 style={{color: 'rgb(163,163,163)', fontWeight: 'bold', margin: '0'}}>
                            Download
                        </h3>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', position: 'relative'}}>
                            {/* Button */}
                            <button onClick={() => setDownloadDropdown(!downloadDropdown)} style={{width: 'fit-content', background: '#FFFF00', fontWeight: 'bold', fontSize: '.875rem', padding: '.5rem 1rem .5rem 1rem', borderRadius: '14px', border: 'none', cursor: 'pointer'}}>
                                <div style={{display: 'flex', gap: '.5rem', alignItems: 'center'}}>
                                    Download
                                </div>
                            </button>

                            <DownloadDropdown setDropdown={setDownloadDropdown} dropdown={downloadDropdown} />
                        </div>
                    </div>
                </div>
                {/* Bottom footer */}
                <div style={{marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid rgb(38,38,38)', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <p style={{color: 'rgb(115,115,115)', fontSize: '.875rem', margin: '0'}}>
                        © 2025 Interview Cheater. All rights reserved.
                    </p>
                </div>
            </footer>
        </Fragment>
	);
  }
  
  export default Footer;
  